import { useState } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import SearchBar from "../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import FilterMenu from "../../components/filterMenu";

const CustomerTopbar = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <>
      <div className="left_s">
        <Box className="search_box">
          <SearchBar
            searchTerm={searchTerm}
            setDebouncedSearchTerm={setSearchTerm}
            placeholder="Search status & membership"
          />
        </Box>
      </div>
  
    </>
  );
};

export default CustomerTopbar;
